export default "__VITE_ASSET__DMuf2biu__"